import tourSelectors from './sections/tourSelectors'
import configSelectors from '../../config/configSelectors'
import panoramaSelectors from './sections/panoramaSelectors'
import interactiveElementsSelectors from './sections/interactiveElementsSelectors'
//Todo: fix VideoSelector from import
import videoSelectors from 'aria-viewer/players/videoplayer/selectors/videoSelectors'
import modalSelectors from './sections/modalSelectors'
import deviceSelectors from './sections/deviceSelectors'
import analyticSelectors from './sections/analyticSelectors'
import paymentSelectors from './sections/paymentSelectors'
import mapSelectors from './sections/mapSelectors'
import slidePanelSelectors from './sections/slidePanelSelectors'
import registrationSelectors from './sections/registrationSelectors'
import ctaPromptSelectors from './sections/ctaPromptSelectors'
import routingSelectors from './sections/routingSelector'
import avatarSelectors from './sections/avatarSelectors'
import stopDescriptionSelectors from './sections/stopDescriptionSelectors'
import { selectors as legacySelectors } from 'aria-viewer/utils/functions'

const selectors = {
    ...tourSelectors,
    ...configSelectors,
    ...videoSelectors,
    ...panoramaSelectors,
    ...interactiveElementsSelectors,
    ...modalSelectors,
    ...deviceSelectors,
    ...analyticSelectors,
    ...paymentSelectors,
    ...slidePanelSelectors,
    ...mapSelectors,
    ...registrationSelectors,
    ...ctaPromptSelectors,
    ...legacySelectors,
    ...routingSelectors,
    ...avatarSelectors,
    ...stopDescriptionSelectors,
}

export default selectors
